import styled from "@emotion/styled"

const ListFiveItemInner = styled.div`
  ${({ theme }) => theme.breakpoints.up("xl")} {
    display: flex;
    flex-grow: 1;
  }

  ${({ theme }) => theme.breakpoints.between("xl", "2xl")} {
    column-gap: 100px;
  }

  ${({ theme }) => theme.breakpoints.up("2xl")} {
    column-gap: 168px;
  }
`

export default ListFiveItemInner
